<template lang="pug">
#modal-buscar-territorios-cadastrados-py
    el-dialog.modal-buscar-territorios-cadastrados-py-content(
        :visible.sync='show',
        :close-on-click-modal='false',
        :close-on-press-escape='false',
        :destroy-on-close='true',
        :show-close='false',
        width='1200px'
    )
        span(slot='title')
            h3
                b {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.paraguai.tituloModalBuscarTerritorios') }}

        .modal-busca-container
            el-input(
                v-model='filtroBusca',
                :placeholder='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.paraguai.placeholderBuscaTerritorios")',
                clearable,
                @input='handleBusca',
                @clear='limparBusca'
            )
                el-button(
                    slot='append',
                    icon='el-icon-search',
                    @click='realizarBusca'
                ) {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.argentina.buscar') }}

        .el-collapse-item__container
            el-table(
                ref='tabelaModalBuscarTerritoriosRef',
                :data='territorios',
                v-loading='carregando',
                style='width: 100% !important'
            )
                el-table-column(width='50')
                    template(slot-scope='scope')
                        el-checkbox(
                            :value='isTerritorioSelecionado(scope.row.id)',
                            :disabled='isTerritorioEmUso(scope.row.id) || (territoriosSelecionados.length >= limiteTerritoriosSelecionados && !isTerritorioSelecionado(scope.row.id))',
                            @change='toggleTerritorio(scope.row)'
                        )

                el-table-column(
                    label='Código Lyra',
                    width='150'
                )
                    .template(slot-scope='scope')
                        span {{ scope.row.codigoLyra || '-' }}

                el-table-column(
                    :label='$t("mensagens.relatorioRastreabilidade.cadastro.territorio")',
                    width='250'
                )
                    .template(slot-scope='scope')
                        span {{ scope.row.nome || '-' }}

                el-table-column(label='Finca', width='100')
                    .template(slot-scope='scope')
                        span(
                            v-if='scope.row.finca && scope.row.finca !== "-" && scope.row.finca !== "null"'
                        ) {{ scope.row.finca }}
                        span(v-else) -

                el-table-column(label='Padron', width='100')
                    .template(slot-scope='scope')
                        span(
                            v-if='scope.row.padron && scope.row.padron !== "-" && scope.row.padron !== "null"'
                        ) {{ scope.row.padron }}
                        span(v-else) -

                el-table-column(
                    :label='$t("mensagens.relatorioRastreabilidade.cadastro.distritoDepartamento")',
                    prop='distritoDepartamento',
                    width='250'
                )
                    template(slot-scope='scope')
                        span(
                            v-if='scope.row.distritoNome && scope.row.departamentoNome'
                        ) {{ scope.row.distritoNome }} / {{ scope.row.departamentoNome }}
                        span(v-else) -

                el-table-column(
                    :label='$t("mensagens.relatorioRastreabilidade.cadastro.saldo")',
                    min-width='280'
                )
                    template(slot-scope='scope')
                        .saldo-container(v-if='scope.row.saldoTerritorioPy && scope.row.saldoTerritorioPy.length > 0')
                            .saldo-info
                                .saldo-labels
                                    span.saldo-label.disponivel
                                        i.el-icon-circle-check
                                        | {{ $t('mensagens.relatorioRastreabilidade.cadastro.saldoDisponivel') }}: {{ formatarSaldo(scope.row.saldoTerritorioPy[0].saldoCapacidadeProdutiva) }}
                                    span.saldo-label.comprometido
                                        i.el-icon-warning
                                        | {{ $t('mensagens.relatorioRastreabilidade.cadastro.saldoComprometido') }}: {{ formatarSaldo(scope.row.saldoTerritorioPy[0].saldoConsumidoCapacidadeProdutiva) }}
                            .saldo-progress
                                el-tooltip(
                                    :content='getTooltipContent(scope.row)',
                                    placement='top'
                                )
                                    .progress-bar
                                        .progress-fill.disponivel(:style='{ width: calcularPercentual(scope.row.saldoTerritorioPy[0].saldoCapacidadeProdutiva, scope.row) + "%" }')
                                        .progress-fill.comprometido(:style='{ width: calcularPercentual(scope.row.saldoTerritorioPy[0].saldoConsumidoCapacidadeProdutiva, scope.row) + "%" }')
                        span(v-else) -

        .c-pagination
            el-pagination(
                background,
                :page-size='pageCount',
                :pager-count='5',
                :current-page.sync='paginaAtual',
                layout='prev, pager, next',
                :total='totalRegistros',
                @current-change='mudarPagina'
            )

        footer.my-3(slot='footer')
            el-button(@click='fecharModal')
                | {{ $t('mensagens.comuns.voltar') }}
            div(v-if='territoriosSelecionados.length === 0')
                el-tooltip(
                    effect='dark',
                    :content='$t("mensagens.relatorioRastreabilidade.cadastro.selecioneUmCarAntesDeConfirmar")',
                    placement='top'
                )
                    el-button(
                        type='primary',
                        @click='retornarDadosSelecionado'
                    )
                        | {{ $t('mensagens.comuns.confirmar') }}
            div(v-else)
                el-button(type='primary', @click='retornarDadosSelecionado')
                    | {{ $t('mensagens.comuns.confirmar') }} ({{ territoriosSelecionados.length }}/{{ limiteTerritoriosSelecionados }})
</template>

<script>
import TerritorioService from '@/services/TerritorioService';

const LIMITE_TERRITORIOS_SELECIONADOS = 10;

export default {
    name: 'ModalBuscarTerritoriosCadastradosPy',

    props: {
        show: {
            type: Boolean,
            required: true
        },
        idsTerritoriosEmUso: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            territoriosSelecionados: [],
            paginaAtual: 1,
            pageCount: 3,
            filtroBusca: '',
            territorios: [],
            totalRegistros: 0,
            carregando: false,
            debounceTimer: null,
            limiteTerritoriosSelecionados: LIMITE_TERRITORIOS_SELECIONADOS
        };
    },

    watch: {
        show: function () {
            if (!this.show) return;
            this.territoriosSelecionados = [];
            this.paginaAtual = 1;
            this.filtroBusca = '';
            this.buscarTerritorios();
        }
    },

    methods: {
        async buscarTerritorios() {
            this.carregando = true;
            try {
                const params = {
                    page: this.paginaAtual - 1,
                    size: this.pageCount,
                    sort: 'data_cadastro,DESC',
                    search: this.filtroBusca || ''
                };

                const response = await TerritorioService.findAll(params);
                this.territorios = response.data.content || [];
                this.totalRegistros = response.data.totalElements || 0;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.erroRequisicao'
                    )
                });
                this.territorios = [];
                this.totalRegistros = 0;
            } finally {
                this.carregando = false;
            }
        },

        handleBusca() {
            clearTimeout(this.debounceTimer);
            this.debounceTimer = setTimeout(() => {
                this.paginaAtual = 1;
                this.buscarTerritorios();
            }, 500);
        },

        realizarBusca() {
            clearTimeout(this.debounceTimer);
            this.paginaAtual = 1;
            this.buscarTerritorios();
        },

        limparBusca() {
            this.filtroBusca = '';
            this.paginaAtual = 1;
            this.buscarTerritorios();
        },

        mudarPagina(currentPage) {
            this.paginaAtual = currentPage;
            this.buscarTerritorios();
        },

        isTerritorioSelecionado(id) {
            return this.territoriosSelecionados.some((t) => t.id === id);
        },

        isTerritorioEmUso(id) {
            return this.idsTerritoriosEmUso.includes(id);
        },

        toggleTerritorio(territorio) {
            if (this.isTerritorioEmUso(territorio.id)) {
                return;
            }

            const idx = this.territoriosSelecionados.findIndex(
                (t) => t.id === territorio.id
            );
            if (idx >= 0) {
                this.territoriosSelecionados.splice(idx, 1);
            } else if (
                this.territoriosSelecionados.length < LIMITE_TERRITORIOS_SELECIONADOS
            ) {
                this.territoriosSelecionados.push(territorio);
            } else {
                this.$notify.warning({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.paraguai.limiteMaximoTerritoriosSelecionados'
                    )
                });
            }
        },

        retornarDadosSelecionado() {
            if (!this.territoriosSelecionados.length) {
                return;
            }
            this.$emit(
                'retornarDadosSelecionados',
                [...this.territoriosSelecionados]
            );
        },

        fecharModal() {
            try {
                this.$messageBox
                    .confirm(
                        this.$t(
                            'mensagens.relatorioRastreabilidade.cadastro.alertaDadosNaoSeraoSalvos'
                        ),
                        this.$t('mensagens.comuns.aviso'),
                        {
                            confirmButtonText: this.$t('mensagens.comuns.sim'),
                            cancelButtonText: this.$t(
                                'mensagens.relatorioRastreabilidade.cadastro.permanecer'
                            ),
                            type: 'warning'
                        }
                    )
                    .then(() => {
                        this.territoriosSelecionados = [];
                        this.$emit('voltar');
                    })
                    .catch(() => {});
            } catch (erro) {}
        },

        formatarSaldo(valor) {
            if (valor === null || valor === undefined) {
                return '0';
            }
            return new Intl.NumberFormat('pt-BR', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2
            }).format(valor);
        },

        calcularPercentual(valor, row) {
            if (!row.saldoTerritorioPy || !row.saldoTerritorioPy.length) {
                return 0;
            }

            const saldo = row.saldoTerritorioPy[0];
            const total = saldo.capacidadeProdutiva || 0;

            if (total === 0) return 0;

            return ((valor / total) * 100).toFixed(2);
        },

        getTooltipContent(row) {
            if (!row.saldoTerritorioPy || !row.saldoTerritorioPy.length) {
                return '';
            }

            const saldo = row.saldoTerritorioPy[0];

            const total = this.formatarSaldo(saldo.capacidadeProdutiva || 0);
            const disponivel = this.formatarSaldo(saldo.saldoCapacidadeProdutiva || 0);
            const comprometido = this.formatarSaldo(saldo.saldoConsumidoCapacidadeProdutiva || 0);

            const percDisponivel = this.calcularPercentual(saldo.saldoCapacidadeProdutiva || 0, row);
            const percComprometido = this.calcularPercentual(saldo.saldoConsumidoCapacidadeProdutiva || 0, row);

            const labelTotal = this.$t('mensagens.relatorioRastreabilidade.cadastro.saldoTotal');
            const labelDisponivel = this.$t('mensagens.relatorioRastreabilidade.cadastro.saldoDisponivel');
            const labelComprometido = this.$t('mensagens.relatorioRastreabilidade.cadastro.saldoComprometido');

            return `${labelTotal}: ${total}  ${labelDisponivel}: ${disponivel} (${percDisponivel}%) ${labelComprometido}: ${comprometido} (${percComprometido}%)`;
        }
    }
};
</script>

<style lang="scss">
#modal-buscar-territorios-cadastrados-py {
    footer {
        display: flex;
        justify-content: space-between;
    }

    .modal-busca-container {
        margin: 20px 0;
        padding: 0 20px;

        .el-input {
            width: 100%;
        }
    }

    .c-pagination {
        text-align: center;
        margin-top: 30px;
    }

    label {
        margin: 0 !important;
    }

    .saldo-container {
        padding: 8px 0;
    }

    .saldo-info {
        margin-bottom: 8px;
    }

    .saldo-labels {
        display: flex;
        justify-content: space-between;
        gap: 12px;
        font-size: 11px;
        margin-bottom: 6px;
    }

    .saldo-label {
        display: flex;
        align-items: center;
        gap: 4px;
        font-weight: 500;

        i {
            font-size: 12px;
        }

        &.disponivel {
            color: var(--primary);

            i {
                color: var(--primary);
            }
        }

        &.comprometido {
            color: #e6a23c;

            i {
                color: #e6a23c;
            }
        }
    }

    .saldo-progress {
        width: 100%;
    }

    .progress-bar {
        display: flex;
        width: 100%;
        height: 20px;
        background-color: #f0f0f0;
        border-radius: 10px;
        overflow: hidden;
        box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
            box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.2);
            transform: scale(1.02);
        }
    }

    .progress-fill {
        height: 100%;
        transition: width 0.4s ease;
        position: relative;

        &.disponivel {
            background: var(--primary);
        }

        &.comprometido {
            background: linear-gradient(90deg, #e6a23c 0%, #f5a742 100%);
        }

        &:first-child:not(:only-child) {
            border-right: 1px solid rgba(255, 255, 255, 0.3);
        }
    }
}

.modal-buscar-territorios-cadastrados-py-content {
    .el-dialog__header {
        padding: 20px;
        padding-bottom: 10px;
        background: var(--primary) !important;
        color: var(--white);
        padding-bottom: 12px;
        padding-top: 12px;
    }

    .el-dialog__headerbtn {
        top: 10px;
    }

    .el-dialog__headerbtn:hover .el-icon-close {
        color: #ffffff;
    }
}
</style>
